import React from "react";
import { Field, Formik, Form } from "formik";
import * as Yup from "yup";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import AppInput from "components/Input/AppInput";
import { FormGroup, makeStyles } from "@material-ui/core";
import AppColor from "utilities/AppColor";
import AppButton from "components/CustomButtons/AppButton";
import { useParams } from "react-router";
import AppConfig from "config/AppConfig";
const { PATTERNS } = AppConfig;
const ChangeEmailForm = (props) => {
  const {
    onSubmit,
    isSubmitting,
    formRef,
    onClose
  } = props;

  const { t } = useTranslation();
  const { id } = useParams();

  const initForm = {
    email: ''
  };

  const handleSubmitForm = (form) => {
    const params = {
      ...form
    };
    if (id) {
      params['id'] = id;
    }
    onSubmit(params);
  };

  const styles = makeStyles(() => ({
    title: {
      display: 'flex',
      margin: '2rem 0 1rem 0',
      '& h5': {
        color: AppColor.mainColor,
      }
    },
    control: {
      display: 'flex',
      flexWrap: 'wrap',
      flexDirection: 'row',
      justifyContent: 'flex-end'
    },
    subLabel: {
      marginBottom: '0.5rem',
      fontSize: '0.8rem'
    }
  }));
  const classes = styles();

  const validationSchema = Yup.object().shape({
    email: Yup.string().trim()
    .required('validation.email.required')
    .email('validation.email.invalid')
    .max(255, { message: 'validation.max_length', value: 255})
    .matches(PATTERNS.BLANK_SPACES, 'validation.blankSpaces'),
  });
  return (
    <Formik
      enableReinitialize={true}
      onSubmit={handleSubmitForm}
      initialValues={initForm}
      validationSchema={validationSchema}
      innerRef={formRef}
    >
      {() => {
        return (
          <Form>
            <Field
              component={AppInput}
              name="email"
              id="changeEmail"
              label={"label.email"}
              required
              strongLabel
            />
            <FormGroup className={classes.control}>
              <AppButton
                label={`${t("button.cancel")}`}
                rounder
                type="button"
                onClick={onClose}
                mode="outlined"
                style={{marginRight: '10px'}}
              />
              <AppButton
                label={`${t("button.save")}`}
                rounder
                type="submit"
                isLoading={isSubmitting}
                disabled={isSubmitting}
              />
            </FormGroup>
          </Form>
        );
      }}
    </Formik >
  );
};

ChangeEmailForm.propTypes = {
  onSubmit: PropTypes.func,
  isSubmitting: PropTypes.bool,
  formRef: PropTypes.any,
  email: PropTypes.string,
  onClose: PropTypes.func
};

export default ChangeEmailForm;
